<!-- {disabled} -->
<button
      class="boton-nico-2 {clases} {outline ? 'outline-class' : ''}"
      on:click
      style="background-color: {outline ? 'transparent' : bgColor};
      color: {outline ? bgColor : color};
      border: {outline ? `2px solid ${bgColor}` : 'none'};"
>
      {#if cargando}
            <IconoNico name="spinner" color={outline ? bgColor : color} />
      {:else}
            <IconoNico name={icono} color={outline ? bgColor : color} />
      {/if}
      {#if texto}
            <span>{texto}</span>
      {/if}
</button>

<script>
      import IconoNico from "./IconoNico.svelte";
      export let texto = "";
      export let icono = "check";
      export let color = "white";
      export let cargando = false;
      export let bgColor = "#7f56da";
      export let outline = false;
      export let clases = "";
      export let disabled = false;

      // export let onClick = () => {
      //       console.log(
      //             "FUNCION NO ASOCIADA AL BOTÓN - NO TENGO LOGICA IMPLEMENTADA PARA ESTE BOTON.. | PARA LLAMAR DESDE AFUERA DEBERIA HACER ALGO COMO ESTO: on:click={() => agregarFila({ id: 123, texto })}"
      //       );
      // };
</script>

<style>
      .boton-nico-2 {
            border-radius: 50px;
            padding: 10px 20px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: 10px; /* Espacio entre ícono y texto */
            font-size: 16px;
            font-weight: bold;
            cursor: pointer;
            transition:
                  background-color 0.3s,
                  color 0.3s;
      }

      .boton-nico-2:hover {
            opacity: 0.8;
      }

      .boton-nico-2:disabled {
            opacity: 0.5;
            cursor: not-allowed;
      }

      .boton-nico-2.outline-class {
            background-color: transparent;
      }
</style>
